import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import React from 'react';
import { translate } from '../../../../../common/intl';
import ErrorBlock from '../../../../components/forms/fields/ErrorBlock';
import { TextField } from '../../../../components/forms/fields-next';
import Text from '../../../../components/Text';
import { Translation } from '../../../../translations/types';
import useStyles from './styles';

interface Props {
  value: string
  replacingAddress?: string
  onCancel: () => void
  onSave: () => void
  onChange: (address: string) => void
  hasError?: boolean
  errorLabel?: string
}

const EditingComponent: React.FC<Props> = ({
  value,
  replacingAddress,
  onCancel,
  onSave,
  onChange,
  hasError,
  errorLabel,
}) => {
  const classes = useStyles();
  return (
    <>
    <Box className={classes.boxContainer}>
      <TextField
        className={classes.textField}
        defaultValue={value}
        onChange={(e) => onChange(e.target.value)}
        error={hasError}
      />
      <Button
        className={classes.cancelButton}
        onClick={onCancel}>
          {translate('common.cancel')}
      </Button>
      <Button
        className={classes.saveButton}
        onClick={onSave}
        disabled={hasError}>
        {translate('common.save')}
      </Button>
    </Box>
    {errorLabel && <ErrorBlock label={errorLabel as Translation} isErrored={Boolean(hasError)} />}
    {!isEmpty(replacingAddress) && (
    <Box className={classes.replacingBox}>
      <Typography variant="h5" className={classes.replacingText}>
        <Text message={translate('common.replacing')} />
      </Typography>
      <FontAwesomeIcon icon={regular('arrow-right')} className={classes.arrowIcon} />
      <span className={classes.replacingText}>{replacingAddress}</span>
    </Box>
    )}
    </>
  );
};

export default EditingComponent;
